import { render, staticRenderFns } from "./FormulateCustomLabel.vue?vue&type=template&id=490656d8"
import script from "./FormulateCustomLabel.vue?vue&type=script&lang=js"
export * from "./FormulateCustomLabel.vue?vue&type=script&lang=js"
import style0 from "./FormulateCustomLabel.vue?vue&type=style&index=0&id=490656d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports